const JsonSchemaKeys = {
  TITLE: "title",
  SCHEMA_NAME: "schemaName",
  JSON_SCHEMA: "jsonSchema"
}

export default JsonSchemaKeys
